/**
 * Что делать с тем, что ввели в адресную строку.
 *
 * Строка принимает и адрес, и поисковый запрос — так устроен любой браузер, и
 * человек вправе набрать «гугл», а не «https://google.com».
 *
 * Первая версия этого не различала и приписывала https:// ко всему подряд.
 * Набранное слово превращалось в несуществующий домен: «гугл» уходило как
 * `https://гугл`, то есть `https://xn--c1aay4a/`, и вкладка падала с
 * ERR_NAME_NOT_RESOLVED. Поймано на живом вводе, а не придумано.
 *
 * Различение простое и намеренно консервативное:
 *   • есть схема — адрес как есть;
 *   • одно слово с точкой и без пробелов — адрес, дописываем схему;
 *   • всё прочее — поисковый запрос.
 *
 * Запрос уходит в Google. Это осознанный выбор по умолчанию, а не единственно
 * возможный: адрес поиска стоит вынести в настройки раздела, когда
 * понадобится — в закрытом контуре запросы наружу могут быть нежелательны.
 */
export function resolveAddress(input: string): string {
  const value = input.trim();

  if (/^https?:\/\//i.test(value)) return value;

  // Точка без пробелов — почти наверняка имя хоста. Локальные имена вроде
  // `localhost:3000` тоже попадают сюда: у них есть двоеточие с портом.
  const looksLikeHost = !/\s/.test(value) && (/\./.test(value) || /^localhost(:\d+)?(\/|$)/i.test(value));

  return looksLikeHost
    ? `https://${value}`
    : `https://www.google.com/search?q=${encodeURIComponent(value)}`;
}
